import React from 'react'
import { Box, Link, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useStyles } from './AccentBox.styles'

type Props = {
  email?: string
  text?: string
  htmlText?: string
}

const AccentBox = ({ email, text, htmlText }: Props) => {
  const classes = useStyles()
  const { t } = useTranslation()

  if (htmlText) {
    return (
      <Box className={classes.container}>
        <Typography
          component="div"
          dangerouslySetInnerHTML={{
            __html: htmlText
          }}
        />
      </Box>
    )
  }

  if (email) {
    return (
      <Box className={classes.container}>
        <Typography component="span">
          {t('news.postgraduate.intro.info2.p1')}{' '}
        </Typography>
        <strong>
          <Link href={`mailto:${email}`} className={classes.link}>
            {email}
          </Link>
        </strong>
      </Box>
    )
  }

  return (
    <Box className={classes.container}>
      <Typography component="strong">{text}</Typography>
    </Box>
  )
}

export default AccentBox
